import type { ResidentListQuery } from '../types'

const PANEL_FILTER_KEYS: Array<keyof ResidentListQuery> = [
  'companyId',
  'propertyId',
  'resident_rental_status',
  'resident_rental_progress',
  'pay_status',
  'reimbursement_type',
  'reimbursement_rental_status',
  'reimbursement_rental_progress',
  'sales_exec_id',
  'advance_search',
  'past_customer',
]

export function countResidentListActiveFilters(
  query: ResidentListQuery,
  options?: { isCompanyLocked?: boolean; isPropertyLocked?: boolean },
): number {
  const isCompanyLocked = options?.isCompanyLocked ?? false
  const isPropertyLocked = options?.isPropertyLocked ?? false

  /** Toolbar search is counted as one active filter (Angular: `q` in session). */
  const searchCount = query.q && String(query.q).trim() ? 1 : 0

  const panelCount = PANEL_FILTER_KEYS.reduce((count, key) => {
    if (key === 'companyId' && isCompanyLocked) return count
    if (key === 'propertyId' && isPropertyLocked) return count
    const value = query[key]
    if (key === 'past_customer') {
      const valStr = value !== undefined && value !== null ? String(value) : ''
      return valStr === '1' || valStr === '2' ? count + 1 : count
    }
    if (Array.isArray(value)) return value.length > 0 ? count + 1 : count
    return value !== undefined && value !== null && value !== ''
      ? count + 1
      : count
  }, 0)

  const leaseCount =
    query.lease_start_daterange ||
    query.lease_start_fromDt ||
    query.lease_start_toDt
      ? 1
      : 0

  return searchCount + panelCount + leaseCount
}
